import { uiUxCard1, uiUxCard2, uiUxCard3 } from '~/assets/images'

export const bigCards = [
  {
    image: uiUxCard1,
    title: 'ui-ux.big-cards.first.title',
    description: 'ui-ux.big-cards.first.description',
  },
  {
    image: uiUxCard2,
    title: 'ui-ux.big-cards.second.title',
    description: 'ui-ux.big-cards.second.description',
  },
  {
    image: uiUxCard3,
    title: 'ui-ux.big-cards.third.title',
    description: 'ui-ux.big-cards.third.description',
  },
]
